import { useFormContext } from 'react-hook-form';

import type { CreateAutoCreditProps } from '../../../types/form-types';

const useAdditionalProducts = () => {
  const { getValues, setValue } = useFormContext<CreateAutoCreditProps>();

  const handleChangeProductInsurance = (data: {
    organizationId: string;
    addProductId: string;
  }) => {
    const additionalProducts = getValues('additionalProducts');
    const addProductsHandler = [...additionalProducts];
    const productIndex = addProductsHandler.findIndex(
      (addProduct) => addProduct.id === data.addProductId
    );

    addProductsHandler[productIndex].insuranceUuid = data.organizationId;
    setValue('additionalProducts', addProductsHandler);
  };

  const handleAddProductsChange = (id: string) => {
    const additionalProducts = getValues('additionalProducts');
    setValue(
      'additionalProducts',
      additionalProducts.map((product) =>
        product.id === id ? { ...product, checked: !product.checked } : product
      )
    );
  };

  const handleChangeAddProductLoanPeriod = (data: {
    value: string;
    id: string;
  }) => {
    const additionalProducts = getValues('additionalProducts');
    const addProductsHandler = [...additionalProducts];
    const productToChangeIndex = addProductsHandler.findIndex(
      (prod) => prod.id === data.id
    );
    addProductsHandler[productToChangeIndex].loanPeriod = data.value;
    setValue('additionalProducts', addProductsHandler);
  };

  return {
    handleChangeProductInsurance,
    handleAddProductsChange,
    handleChangeAddProductLoanPeriod
  };
};

export default useAdditionalProducts;
